import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
    providedIn: "root",
})
export class CourrierService {
    constructor(private http: HttpClient) { }


    list(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:list",
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    html(id: number, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:html",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    htmlMulti(id: number, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:htmlMulti",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    get(id: number, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:get",
            params: {
                id: id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
     gets(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:gets",
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    

    getParamsCourrier(): Observable<any> {
        let rpcMethod = new JSONRpc(
            {
                jsonrpc: "2.0",
                method: "webservice.parametre:courrier",
                params: {
                }
            }
        )
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    getCourriersType(demandeType: string = 'DOSSIER'): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:defaut",
            params: {
                options: {
                    demande_type: demandeType
                },
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    setCourrierEtat(demandedcourrierid: number, etat: number): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:etat",
            params: {
                id: demandedcourrierid,
                etat: etat,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    setCourrierRestore(demandecourrierid: number): Observable<JSONRpcResponse> {
        return this.setCourrierEtat(demandecourrierid, 1)
    }

    setCourrierDelete(demandecourrierid: number): Observable<JSONRpcResponse> {
        return this.setCourrierEtat(demandecourrierid, 0)
    }
	
	getSignataireList(idcourrier: number , options: any = []): Observable<JSONRpcResponse> {
	    let rpcMethod = new JSONRpc({
	        jsonrpc: "2.0",
	        method: "webservice.courrier:signataires",
	        params: {
	             id: idcourrier,
	             options: options
	        },
	    })
	    return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getSignature(idtiers: number , options: any = []): Observable<JSONRpcResponse> {
	    let rpcMethod = new JSONRpc({
	        jsonrpc: "2.0",
	        method: "webservice.courrier:signature",
	        params: {
	             id: idtiers,
	             options: options
	        },
	    })
	    return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}




    // setCourrierByInstruction(demandeid: any, courrier: any, dossier: any = 0, demande_type: string = 'DOSSIER'): Observable<JSONRpcResponse> {
    //     let rpcMethod = new JSONRpc({
    //         jsonrpc: "2.0",
    //         method: "webservice.courrier:set",
    //         params: {
    //             courriers: [courrier],
    //             options: {
    //                 demande: demandeid,
    //             },
    //         },
    //     });
    //     if (demandeid == 0) {
    //         rpcMethod.params.options.dossier = dossier;
    //         rpcMethod.params.options.demande_type = demande_type;
    //     }

    //     return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }


    // getCourrier(demandecourrier: any, demande: any, format: string, iddemandecourrier?: string, libres?: any, destinataire?: any): Promise<any> {
    //     let rpcMethod = new JSONRpc(
    //         {
    //             jsonrpc: "2.0",
    //             method: "webservice.courrier:get",
    //             params: {
    //                 id: iddemandecourrier ? iddemandecourrier : '0',
    //                 options: {
    //                     "demande": demande.ID,
    //                     "courrier": demandecourrier.key,
    //                     "html": demandecourrier.html,
    //                     "format": format,
    //                     "libres": libres,
    //                     "destination": destinataire
    //                 }
    //             }
    //         }
    //     )
    //     return this.http.post<JSONRpc>(environment.webservice, rpcMethod).toPromise();
    // }



    // getList(_id: string, _options: any, _nodata?: boolean): Observable<any> {
    //     let json = {
    //         jsonrpc: "2.0",
    //         method: "webservice.liste:get",

    //         params: {
    //             id: _id,
    //             options: _options
    //         }
    //     }

    //     if (_nodata) {
    //         json["params"]["options"] = {
    //             nodata: _nodata
    //         };
    //     }
    //     let rpcMethod = new JSONRpc(json)

    //     return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }




    // getListCourrier(): Observable<any> {
    //     let rpcMethod = new JSONRpc(
    //         {
    //             jsonrpc: "2.0",
    //             method: "webservice.courrier:list",
    //             params: {
    //                 options: {

    //                 }
    //             }
    //         }
    //     )
    //     return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }



    // generateCourriers(courriers, instructionID): Observable<any> {
    //     let rpcMethod = new JSONRpc(
    //         {
    //             jsonrpc: "2.0",
    //             method: "webservice.courrier:init",
    //             "params": {
    //                 "types": courriers,

    //                 "options": {
    //                     "instruction": instructionID
    //                 }

    //             }
    //         }
    //     )
    //     return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    // }


}
